import { headers } from "@utils/utils";

const useProductoStore = defineStore("producto", () => {
  // state
  const producto = ref({
    id: null,
    nombre: "",
    breve: "",
    categoria_id: null,
    precio: 0,
    costo: 0,
    descripcion: null,
    cantidad: 1,
    caracteristicas: [],
    envio: {
      precio: 0,
      condiciones: "",
    },
    archivo: null,
    categoria: null,
    imagenes: [], // es un array de objetos {hash_name,url} imagenes
    enviable: false,
    is_entregable: false, // default = false
    digital: false,
    beneficios: [],
    regalable: false,
  });

  const productos = ref([]);

  // getters
  const draft = computed(() => clone(producto.value));

  // methods
  const setProducto = (cat) => {
    producto.value = cat;
  };

  const setProductos = (products) => {
    productos.value = products;
  };

  const agregarCaracteristica = () => {
    producto.value.caracteristicas.push({
      nombre: "",
      valor: "",
    });
  };

  const quitarCaracteristicas = () => {
    producto.value.caracteristicas = [];
  };

  const quitarCaracteristica = (i) => {
    producto.value.caracteristicas.splice(i, 1);
  };

  const quitarImagen = (imagen_id) => {
    let i = producto.value.imagenes.findIndex((v) => v.id === imagen_id);
    if (i != -1) {
      producto.value.imagenes.splice(i, 1);
    }
  };

  const toggleEnvio = (val) => {
    if (val) {
      producto.value.envio = {
        precio: 0,
        condiciones: "",
      };
    } else {
      producto.value.envio = null;
    }
  };

  const clear = () => {
    producto.value = {
      id: null,
      nombre: "",
      breve: "",
      categoria_id: null,
      precio: 0,
      costo: 0,
      descripcion: null,
      cantidad: 1,
      caracteristicas: [],
      envio: {
        precio: 0,
        condiciones: "",
      },
      archivo: null,
      categoria: null,
      imagenes: [],
      enviable: false,
      is_entregable: false, // default = false
      digital: false,
      beneficios: [],
      regalable: false,
    };
  };

  // methods actions

  const pushImagen = (data) => {
    producto.value.imagenes.push(data);
  };

  const fetch = async (cat_id) => {
    try {
      const response = await axios.get(`/api/productos/${cat_id}/fetch-data`);
      const data = response.data;

      return data;
    } catch (error) {
      console.log("Error fetching product:", error);
    }
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/productos/fetch-data`, params)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/productos/${datos.id}`, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        axios
          .post(`/api/productos`, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (produc_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/productos/${produc_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const rangoPrecios = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/productos/rango-precios`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const eliminarImagen = (imagen_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/imagens/${imagen_id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const cargarImagen = ({ imagenes }) => {
    let formData = new FormData();

    imagenes.forEach((val) => {
      formData.append("imagen[]", val);
    });

    formData.append("_method", "put");

    return new Promise((resolve, reject) => {
      axios
        .post(`/api/productos/${producto.value.id}/cargar/imagen`, formData, {
          headers,
        })
        .then(({ data }) => {
          if (data.result) {
            setProducto(data.producto);
          }

          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchListSelect = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/productos/get/list-select`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    // state,
    producto,
    productos,
    // methods
    setProducto,
    setProductos,
    clear,
    fetch,
    fetchData,
    guardar,
    eliminar,
    fetchListSelect,
    rangoPrecios,
    agregarCaracteristica,
    quitarCaracteristicas,
    quitarCaracteristica,
    toggleEnvio,
    pushImagen,
    cargarImagen,
    eliminarImagen,
    quitarImagen,
  };
});

export default useProductoStore;
